export const OKTA_URL = import.meta.env.VITE_OKTA_URL ?? "";
export const OKTA_CLIENT_ID = import.meta.env.VITE_OKTA_CLIENT_ID ?? "";
export const OKTA_REDIRECT_URL = import.meta.env.VITE_OKTA_REDIRECT_URL ?? "";

export const STORAGE_KEY = {
  LOCATION_BEFORE_AUTH: "compass-location_before_auth",
  TOKEN_DATA: "compass-token_data",
  CODE_VERIFIER: "compass-pkce_code_verifier",
  OAUTH_STATE: "compass-oauth_state",
} as const;
